export let notes = [
    {
        title: "Dried beans",
        text: "If you want to use dried beans here, use 3 cups cooked and drained pinto beans in place of the canned ones."
    },
    {
      title: "Buy extra lavash",
      text: "It’s a good idea to buy more lavash than you need, just in case some of it is torn or too narrow to yield the necessary 11-inch long strips. Lavash is commonly sold in 1-pound packages; 1 ½ pounds lavash should be more than enough."
    },
    {
      title: "Spraying lavash with water",
      text: "Be liberal with water when spraying the lavash strips, particularly if your lavash seems fragile. It can handle a lot of moisture, and any excess will evaporate during baking."
    },
    {
      title: "Aleppo peppers",
      text: "Aleppo chile peppers, which have been cultivated in Syria for centuries, are quite mild in terms of heat, with a hint of raisin-y, sun-dried tomato sweetness. Due to the ongoing civil war, true Aleppo pepper from Syria is no longer available for import, but chiles grown in neighboring Turkey are. You can find Aleppo pepper at Middle Eastern markets, or online. Korean gochugaru or paprika (plus 1/8 teaspoon cayenne to add heat to the latter) can be substituted for Aleppo pepper in this recipe."
    },
    {
      title: "Make-ahead",
      text: "<p>The herb sauce can be held in the fridge for up to 48 hours; allow to warm to room temperature before serving.</p><p>To make the triangles ahead of time, it is best to bake them off, cool them to room temperature, and then refrigerate them in an airtight container for up to 2 days. (Or freeze for up to 3 weeks.)</p>"
    },
    {
      title: "Reheating",
      text: "To reheat, place on a wire rack set inside a rimmed baking sheet in a 350˚F oven for 15 to 20 minutes (20 to 25 if frozen)"
    }
]